package com.sweetlime.bingeamigo.model

import kotlinx.serialization.Serializable

@Serializable
data class UserProfile(
    val id: String = "",
    val username: String = "",
    val usernameLower: String = "",
    val avatarUrl: String = "",
    val xp: Int = 0,
    val level: Int = 1
)